import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { I as InputLabel } from '../InputLabel/InputLabel-DkkiEzm3.js';
import { F as Flex } from '../Flex/Flex-77mGg7gI.js';
import { B as Button } from '../Button/Button-Cwlb3sfd.js';

const StyledLabelLine = /*#__PURE__*/styled(InputLabel).withConfig({
  componentId: "sc-storm-ui-40026394__sc-amnlzo-0"
})(["display:", ";align-items:center;margin-block-end:", ";margin-inline-end:", ";", ""], ({
  $inline
}) => $inline ? 'inline-flex' : 'flex', ({
  $inline,
  theme
}) => $inline ? '0' : theme.controls.blockLabelGapSm.default, ({
  $inline,
  theme
}) => $inline ? theme.controls.labelGap.default : '0', isMobile(css(["margin-block-end:", ";margin-inline-end:", ";"], ({
  $inline,
  theme
}) => $inline ? '0' : theme.controls.blockLabelGapSm.mobile, ({
  $inline,
  theme
}) => $inline ? theme.controls.labelGap.mobile : '0')));
const DropdownButtonContent = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40026394__sc-amnlzo-1"
})(["overflow:hidden;text-overflow:ellipsis;flex:1;text-align:start;"]);
const StyledDropdownButton = /*#__PURE__*/styled(Button).withConfig({
  componentId: "sc-storm-ui-40026394__sc-amnlzo-2"
})(["display:", ";width:", ";", ""], ({
  $inline
}) => $inline ? 'inline-flex' : 'flex', ({
  $fullWidth
}) => $fullWidth ? '100%' : 'auto', ({
  $error,
  theme
}) => $error && `
    border: ${theme.support.border.error};
    :hover {
      border: ${theme.support.border.error};
    }
    :active {
      border: ${theme.support.border.error};
    }
  `);
const Wrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-amnlzo-3"
})(["width:", ";display:inline-block;", ""], ({
  $fullWidth
}) => $fullWidth ? '100%' : 'auto', ({
  $inline
}) => $inline && css(["display:inline-flex;align-items:center;"]));
Wrapper.displayName = 'Wrapper';
const PopoverContentContainerWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-amnlzo-4"
})(["padding-block:", ";padding-inline:0;", ";box-sizing:border-box;"], ({
  theme
}) => theme.dropdown.popover.offsetScrollbar, ({
  $fullWidth,
  $minWidth
}) => {
  /* Only set a min-width if we get a positive number. */
  const minWidth = $minWidth && $minWidth >= 0 ? $minWidth : undefined;
  return minWidth ? `
      width: ${$fullWidth ? `${minWidth}px` : 'auto'};
      min-width: ${minWidth}px;
    ` : '';
});
const OverflowWrapper = /*#__PURE__*/styled(Flex).withConfig({
  componentId: "sc-storm-ui-40026394__sc-amnlzo-5"
})(["max-height:", ";overflow-x:hidden;overflow-y:auto;"], ({
  $maxHeight,
  theme
}) => $maxHeight !== null && $maxHeight !== void 0 ? $maxHeight : theme.dropdown.popover.maxHeight);

export { DropdownButtonContent as D, OverflowWrapper as O, PopoverContentContainerWrapper as P, StyledLabelLine as S, Wrapper as W, StyledDropdownButton as a };
//# sourceMappingURL=Dropdown.styles-Wj3QvlFN.js.map
